module.exports = __webpack_public_path__ + "img/videojs.42d8f872.svg";